import React from 'react'

import Sad from 'assets/svg/sad_.svg'

import Button from 'components/Button'
import {
    Container,
    Actions,
    Content,
    Desc,
    Label,
    Warning,
    Info
} from './CartMenu.style'

const CartEmpty = ({ open = () => {} }) => {
    return (
        <Container>
            <Content>
                <Warning>
                    <img className="alelo_sad" src={Sad} alt="Alelo Sad" />
                    <Desc>
                        <Label>Sua cesta está vazia</Label>
                        <Info>
                            Você ainda não adicionou nenhum produto a sua cesta
                            de proposta.
                        </Info>
                    </Desc>
                </Warning>
                <Actions>
                    <Button
                        id="cartAddProducts"
                        type="button"
                        kind="basic"
                        onClick={open}
                    >
                        Adicionar Produtos
                    </Button>
                </Actions>
            </Content>
        </Container>
    )
}

export default CartEmpty
